/// <amd-module name="Dashboards/Directory/DashboardsDirectoryContracts" />
import { DashboardScope } from "Dashboards/Common/Contracts/Dashboard";
import { IDirectoryArtifact } from "VSS/Features/Directory/DirectoryContracts";

import { ISimpleTableCell } from "VSSUI/Table";
 
/**
 * Represents a dashboard in the format recognized by the directory stack.
 */
export interface IDashboardsDirectoryArtifact extends IDirectoryArtifact {
    /**
     * Description of the dashboard.
     */
    description: string;

    /**
     * Flattened field for the dashboard owner, used for sorting/searching.
     */
    ownerName: string;

    ownerImageUrl?: string;

    /**
     * Type or scope of the dashboard - Project/Team.
     */
    dashboardScope: DashboardScope;

    /**
     * Dashboard Last Accessed Date.
     */
    lastAccessedDate: string;
    /**
     * Id of the person who modified Dashboard.
     */
    modifiedBy: string;
    /**
     * Dashboard's last modified date.
     */
    modifiedDate: string;

    /**
     * Flattened field for the dashboard modified by, used for sorting/searching.
     */
    modifiedByName: string;

    modifiedByImageUrl?: string;
}

/**
 * An interface composed of a subset of properties copied from CreatedDashboardItem in CreateDashboardDialogModels.ts
 * in the old web platform. Used for interacting with the results of the new dashboard dialog which is rendered using a legacy component.
 */
export interface NewDashboardItem {
    /**
     * ID of the Dashboard. Provided by service at creation time.
     */
    id: string;
    /**
     * The team ID.
     */
    teamId: string;
    /**
     * The team project ID.
     */
    projectId: string;
}
export interface IDashboardsDirectoryAwareState {
    dashboardsDirectoryState: IDashboardsDirectoryState;
}

export interface IDashboardsDirectoryState {
    directoryArtifactState: IDashboardsDirectoryArtifactState;
}

export interface IDashboardsDirectoryArtifactState {
    myDashboards: Dashboard[];
    favorites: DashboardFavoriteWithOwner[];
    myOwners: Owner[];
    mruDashboard: DashboardWithOwner;
    allDashboards: Dashboard[];
    allOwners: Owner[];
    canCreateDashboardsPermission: boolean;
    canManageDashboardsSecurityPermission: boolean;
    canDeleteDashboardsPermission: boolean;
    canUseTeamPanelPermission: boolean;
}

export interface Dashboard extends ISimpleTableCell {
    id: string;
    name: string;
    dashboardScope: DashboardScope;
    description: string;
    ownerId: string;
    lastAccessedDate: string;
    modifiedBy: string;
    modifiedDate: string;
}

export interface DataProviderOwner {
    value: Owner;
}

export interface Owner {
    id: string;
    name: string;
    imageUrl: string;
}

export interface DashboardWithOwner {
    dashboard: Dashboard;
    owner: Owner;
}

export interface DashboardFavoriteWithOwner extends DashboardWithOwner {
    favorite: Favorite;
}

interface Favorite {
    id: string;
    artifactId: string;
    artifactName: string;
    artifactIsDeleted: boolean;
}

export interface DashboardsAndOwnersLists {
    dashboards: Dashboard[];
    owners: Owner[];
}

export interface Team {
    id: string;
    name: string;
}